<template>
  <div class="container">
    <div class="search">
      <el-input v-model="input" class="oinput" placeholder="请输入内容" size="small"></el-input>
      <el-button size="small" type="primary">查询</el-button>
    </div>
    <div class="itemNav">
      <span>
        <el-checkbox v-model="allChecked">全选</el-checkbox>
      </span>
    </div>
    <div class="item" v-for="(item,index) in 5" :key="index">
      <span>
        <el-checkbox v-model="allChecked"></el-checkbox>
      </span>
      <span>
        <div>
          <img
            src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1588927627793&di=e226d4011f62af3b348a9423c7b06843&imgtype=0&src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201708%2F29%2F20170829182932_NxVad.thumb.700_0.jpeg"
            alt
          />
          <div>
            <h3>New Product</h3>
            <p>已上架 26 个商品</p>
          </div>
        </div>
      </span>
    </div>
    <!-- 分页 -->
    <div class="pag">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="30"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="20"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allChecked: false,
      input: ""
    };
  }
};
</script>

<style lang="less" scoped>
.itemNav,
.item {
  padding-left: 18px;
  span {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 16px;
  }
  span:nth-child(1) {
    width: 30px;
    display: inline-block;
    margin-right: 0;
  }
  span:nth-child(2) {
    display: inline-block;
    text-align: center;
    width: 6%;
  }
  span:nth-child(2) {
    display: inline-block;
    text-align: center;
    width: 80%;
    font-size: 12px;
    > div {
      display: flex;
      align-items: center;
      > div {
        text-align: left;
        margin-left: 20px;
        h3 {
          color: #606226;
        }
        p {
          color: #999;
        }
      }
    }
  }
}
.itemNav {
  margin-bottom: 10px;
}
.item {
  background: rgba(246, 249, 252, 1);
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  height: 68px;
  padding: 0;
  padding-left: 18px;
  &:hover {
    background-color: #eee;
  }
  span {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  span:nth-child(2) {
    img {
      width: 50px;
      height: 50px;
    }
  }
  span:nth-child(3) {
    color: #333;
  }
  span:nth-child(5) {
    color: #333333;
  }
}
.pag {
  margin: 22px 0;
  text-align: center;
  /deep/ .btn-prev,
  /deep/ .btn-next {
    padding: 0 8px;
  }
}
.search {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  .oinput {
    width: 300px;
    margin-right: 10px;
  }
}
</style>